module.exports = __webpack_public_path__ + "static/media/art55.6d9363be.jpg";